export default __webpack_public_path__ + "static/hero-img-3bcc8a5410573c36efe63e3656c5af47.png";